import { createTranslations } from '@/i18n/types';

const translations = createTranslations({
  en: {
    title: 'Achievements',
    achievementsTitle: 'Trophies',
    counter: '{earned} / {total}',
    locked: 'Nothing earned yet',
    userLocked: 'This player has not earned anything yet',
    loading: 'Loading…',
    userNotFound: 'User not found',
    loadFailed: 'Failed to load achievements',
    secret: 'Secret achievement',
    unlockedAt: 'Earned {{date}}',
    progress: 'Progress',
    ownedByPercent: '{{percent}}% of players have it',
    reward: 'Reward',
    claimReward: 'Claim reward',
    depositToUnlock: 'Deposit to unlock',
    recentReceivers: 'Recently earned by',
    noOneUnlocked: 'Nobody earned this yet',
    you: 'You',
    today: 'Today',
    receivedBy: 'Earned by',
    playerOne: 'player',
    playerFew: 'players',
    playerMany: 'players',
    achievementUnlocked: 'Achievement unlocked: {title}',
    achievementUnlockedFallback: 'Achievement unlocked!',
    whatIsThis: 'What is this?',
    categoryAll: 'All',
    categoryCases: 'Cases',
    categoryUpgrades: 'Upgrades',
    categoryContracts: 'Contracts',
    categoryDeposits: 'Deposits',
    categorySteam: 'Steam',
    categoryFriends: 'Friends',
    categoryActivity: 'Activity',
    categorySecret: 'Secret',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Case Battles',
    legendCredited: 'Credited',
    legendUnclaimed: 'Reward pending',
  },
  ru: {
    title: 'Трофеи',
    achievementsTitle: 'Трофеи',
    counter: '{earned} / {total}',
    locked: 'Пока ничего не получено',
    userLocked: 'Этот игрок пока ничего не получил',
    loading: 'Загрузка…',
    userNotFound: 'Пользователь не найден',
    loadFailed: 'Не удалось загрузить достижения',
    secret: 'Секретная ачивка',
    unlockedAt: 'Получено {{date}}',
    progress: 'Прогресс',
    ownedByPercent: 'Есть у {{percent}}% игроков',
    reward: 'Награда',
    claimReward: 'Забрать награду',
    depositToUnlock: 'Пополни, чтобы забрать',
    recentReceivers: 'Недавно получили',
    noOneUnlocked: 'Пока никто не получил',
    you: 'Ты',
    today: 'Сегодня',
    receivedBy: 'Получили:',
    playerOne: 'игрок',
    playerFew: 'игрока',
    playerMany: 'игроков',
    achievementUnlocked: 'Получена ачивка: {title}',
    achievementUnlockedFallback: 'Ачивка получена!',
    whatIsThis: 'Что это такое?',
    categoryAll: 'Все',
    categoryCases: 'Кейсы',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Контракты',
    categoryDeposits: 'Пополнения',
    categorySteam: 'Steam',
    categoryFriends: 'Друзья',
    categoryActivity: 'Активность',
    categorySecret: 'Секретные',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Кейсбаттлы',
    legendCredited: 'Зачислено',
    legendUnclaimed: 'Награда ждёт',
  },
  uz: {
    title: 'Yutuqlar',
    achievementsTitle: 'Kuboklar',
    counter: '{earned} / {total}',
    locked: 'Hali hech narsa olinmagan',
    userLocked: 'Bu oʻyinchi hali hech narsa olmagan',
    loading: 'Yuklanmoqda…',
    userNotFound: 'Foydalanuvchi topilmadi',
    loadFailed: 'Yutuqlarni yuklab boʻlmadi',
    secret: 'Maxfiy yutuq',
    unlockedAt: '{{date}} da olindi',
    progress: 'Jarayon',
    ownedByPercent: 'Oʻyinchilarning {{percent}}% da bor',
    reward: 'Mukofot',
    claimReward: 'Mukofotni olish',
    depositToUnlock: 'Olish uchun toʻldir',
    recentReceivers: 'Yaqinda oldilar',
    noOneUnlocked: 'Hali hech kim olmadi',
    you: 'Sen',
    today: 'Bugun',
    receivedBy: 'Oldi:',
    playerOne: 'oʻyinchi',
    playerFew: 'oʻyinchi',
    playerMany: 'oʻyinchi',
    achievementUnlocked: 'Yutuq ochildi: {title}',
    achievementUnlockedFallback: 'Yutuq ochildi!',
    whatIsThis: 'Bu nima?',
    categoryAll: 'Barchasi',
    categoryCases: 'Keyslar',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Kontraktlar',
    categoryDeposits: 'Toʻldirish',
    categorySteam: 'Steam',
    categoryFriends: 'Doʻstlar',
    categoryActivity: 'Faollik',
    categorySecret: 'Maxfiy',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Keysbattlar',
    legendCredited: 'Hisoblandi',
    legendUnclaimed: 'Mukofot kutilmoqda',
  },
  fa: {
    title: 'دستاوردها',
    achievementsTitle: 'جام‌ها',
    counter: '{earned} / {total}',
    locked: 'هنوز چیزی نگرفته‌ای',
    userLocked: 'این بازیکن هنوز چیزی نگرفته است',
    loading: 'در حال بارگذاری…',
    userNotFound: 'کاربر پیدا نشد',
    loadFailed: 'دستاوردها بارگذاری نشدند',
    secret: 'دستاورد مخفی',
    unlockedAt: 'گرفته‌شده در {{date}}',
    progress: 'پیشرفت',
    ownedByPercent: '{{percent}}% بازیکنان دارندش',
    reward: 'جایزه',
    claimReward: 'جایزه را بگیر',
    depositToUnlock: 'برای باز شدن شارژ کن',
    recentReceivers: 'به‌تازگی گرفته‌اند',
    noOneUnlocked: 'هنوز کسی این را نگرفته',
    you: 'تو',
    today: 'امروز',
    receivedBy: 'گرفته‌شده توسط',
    playerOne: 'بازیکن',
    playerFew: 'بازیکن',
    playerMany: 'بازیکن',
    achievementUnlocked: 'دستاورد باز شد: {title}',
    achievementUnlockedFallback: 'دستاورد باز شد!',
    whatIsThis: 'این چیست؟',
    categoryAll: 'همه',
    categoryCases: 'کیس‌ها',
    categoryUpgrades: 'ارتقاها',
    categoryContracts: 'قراردادها',
    categoryDeposits: 'شارژها',
    categorySteam: 'استیم',
    categoryFriends: 'دوستان',
    categoryActivity: 'فعالیت',
    categorySecret: 'مخفی',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'کیس‌بتل',
    legendCredited: 'واریز‌شده',
    legendUnclaimed: 'جایزه در انتظار',
  },
  pt: {
    title: 'Conquistas',
    achievementsTitle: 'Troféus',
    counter: '{earned} / {total}',
    locked: 'Nada conquistado ainda',
    userLocked: 'Esse jogador ainda não conquistou nada',
    loading: 'Carregando…',
    userNotFound: 'Usuário não encontrado',
    loadFailed: 'Não deu para carregar as conquistas',
    secret: 'Conquista secreta',
    unlockedAt: 'Conquistada em {{date}}',
    progress: 'Progresso',
    ownedByPercent: '{{percent}}% dos jogadores têm',
    reward: 'Recompensa',
    claimReward: 'Pegar recompensa',
    depositToUnlock: 'Deposite para pegar',
    recentReceivers: 'Conquistaram há pouco',
    noOneUnlocked: 'Ninguém conquistou ainda',
    you: 'Você',
    today: 'Hoje',
    receivedBy: 'Conquistaram:',
    playerOne: 'jogador',
    playerFew: 'jogadores',
    playerMany: 'jogadores',
    achievementUnlocked: 'Conquista desbloqueada: {title}',
    achievementUnlockedFallback: 'Conquista desbloqueada!',
    whatIsThis: 'O que é isso?',
    categoryAll: 'Todas',
    categoryCases: 'Caixas',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Contratos',
    categoryDeposits: 'Depósitos',
    categorySteam: 'Steam',
    categoryFriends: 'Amigos',
    categoryActivity: 'Atividade',
    categorySecret: 'Secretas',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Batalhas',
    legendCredited: 'Creditada',
    legendUnclaimed: 'Recompensa pendente',
  },
  tr: {
    title: 'Başarımlar',
    achievementsTitle: 'Kupalar',
    counter: '{earned} / {total}',
    locked: 'Henüz bir şey kazanılmadı',
    userLocked: 'Bu oyuncu henüz bir şey kazanmadı',
    loading: 'Yükleniyor…',
    userNotFound: 'Kullanıcı bulunamadı',
    loadFailed: 'Başarımlar yüklenemedi',
    secret: 'Gizli başarım',
    unlockedAt: '{{date}} kazanıldı',
    progress: 'İlerleme',
    ownedByPercent: "Oyuncuların %{{percent}}'inde var",
    reward: 'Ödül',
    claimReward: 'Ödülü al',
    depositToUnlock: 'Almak için bakiye yükle',
    recentReceivers: 'Yakın zamanda kazananlar',
    noOneUnlocked: 'Henüz kimse kazanmadı',
    you: 'Sen',
    today: 'Bugün',
    receivedBy: 'Kazananlar:',
    playerOne: 'oyuncu',
    playerFew: 'oyuncu',
    playerMany: 'oyuncu',
    achievementUnlocked: 'Başarım kazanıldı: {title}',
    achievementUnlockedFallback: 'Başarım kazanıldı!',
    whatIsThis: 'Bu ne?',
    categoryAll: 'Tümü',
    categoryCases: 'Kasalar',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Kontratlar',
    categoryDeposits: 'Yatırmalar',
    categorySteam: 'Steam',
    categoryFriends: 'Arkadaşlar',
    categoryActivity: 'Aktivite',
    categorySecret: 'Gizli',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Kasa savaşları',
    legendCredited: 'Yatırıldı',
    legendUnclaimed: 'Ödül bekliyor',
  },
  uk: {
    title: 'Трофеї',
    achievementsTitle: 'Трофеї',
    counter: '{earned} / {total}',
    locked: 'Поки нічого не отримано',
    userLocked: 'Цей гравець поки нічого не отримав',
    loading: 'Завантаження…',
    userNotFound: 'Користувача не знайдено',
    loadFailed: 'Не вдалося завантажити досягнення',
    secret: 'Секретне досягнення',
    unlockedAt: 'Отримано {{date}}',
    progress: 'Прогрес',
    ownedByPercent: 'Є у {{percent}}% гравців',
    reward: 'Нагорода',
    claimReward: 'Забрати нагороду',
    depositToUnlock: 'Поповни, щоб забрати',
    recentReceivers: 'Нещодавно отримали',
    noOneUnlocked: 'Поки ніхто не отримав',
    you: 'Ти',
    today: 'Сьогодні',
    receivedBy: 'Отримали:',
    playerOne: 'гравець',
    playerFew: 'гравці',
    playerMany: 'гравців',
    achievementUnlocked: 'Отримано досягнення: {title}',
    achievementUnlockedFallback: 'Досягнення отримано!',
    whatIsThis: 'Що це таке?',
    categoryAll: 'Усі',
    categoryCases: 'Кейси',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Контракти',
    categoryDeposits: 'Поповнення',
    categorySteam: 'Steam',
    categoryFriends: 'Друзі',
    categoryActivity: 'Активність',
    categorySecret: 'Секретні',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Кейс-батли',
    legendCredited: 'Зараховано',
    legendUnclaimed: 'Нагорода чекає',
  },
  de: {
    title: 'Trophäen',
    achievementsTitle: 'Trophäen',
    counter: '{earned} / {total}',
    locked: 'Noch nichts erhalten',
    userLocked: 'Dieser Spieler hat noch nichts erhalten',
    loading: 'Lädt…',
    userNotFound: 'Nutzer nicht gefunden',
    loadFailed: 'Trophäen konnten nicht geladen werden',
    secret: 'Geheime Trophäe',
    unlockedAt: 'Erhalten am {{date}}',
    progress: 'Fortschritt',
    ownedByPercent: '{{percent}}% der Spieler haben sie',
    reward: 'Belohnung',
    claimReward: 'Belohnung abholen',
    depositToUnlock: 'Lade auf, um sie abzuholen',
    recentReceivers: 'Zuletzt erhalten von',
    noOneUnlocked: 'Noch niemand hat sie erhalten',
    you: 'Du',
    today: 'Heute',
    receivedBy: 'Erhalten von:',
    playerOne: 'Spieler',
    playerFew: 'Spieler',
    playerMany: 'Spieler',
    achievementUnlocked: 'Trophäe erhalten: {title}',
    achievementUnlockedFallback: 'Trophäe erhalten!',
    whatIsThis: 'Was ist das?',
    categoryAll: 'Alle',
    categoryCases: 'Cases',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Contracts',
    categoryDeposits: 'Aufladungen',
    categorySteam: 'Steam',
    categoryFriends: 'Freunde',
    categoryActivity: 'Aktivität',
    categorySecret: 'Geheim',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Case Battles',
    legendCredited: 'Gutgeschrieben',
    legendUnclaimed: 'Belohnung wartet',
  },
  es: {
    title: 'Trofeos',
    achievementsTitle: 'Trofeos',
    counter: '{earned} / {total}',
    locked: 'Aún no has conseguido nada',
    userLocked: 'Este jugador aún no ha conseguido nada',
    loading: 'Cargando…',
    userNotFound: 'Usuario no encontrado',
    loadFailed: 'No se pudieron cargar los logros',
    secret: 'Logro secreto',
    unlockedAt: 'Conseguido el {{date}}',
    progress: 'Progreso',
    ownedByPercent: 'Lo tiene el {{percent}}% de los jugadores',
    reward: 'Recompensa',
    claimReward: 'Recoger recompensa',
    depositToUnlock: 'Recarga para recoger',
    recentReceivers: 'Lo consiguieron hace poco',
    noOneUnlocked: 'Nadie lo ha conseguido aún',
    you: 'Tú',
    today: 'Hoy',
    receivedBy: 'Lo consiguieron:',
    playerOne: 'jugador',
    playerFew: 'jugadores',
    playerMany: 'jugadores',
    achievementUnlocked: 'Logro conseguido: {title}',
    achievementUnlockedFallback: '¡Logro conseguido!',
    whatIsThis: '¿Qué es esto?',
    categoryAll: 'Todos',
    categoryCases: 'Cajas',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Contratos',
    categoryDeposits: 'Recargas',
    categorySteam: 'Steam',
    categoryFriends: 'Amigos',
    categoryActivity: 'Actividad',
    categorySecret: 'Secretos',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Case Battles',
    legendCredited: 'Acreditado',
    legendUnclaimed: 'Recompensa pendiente',
  },
  pl: {
    title: 'Trofea',
    achievementsTitle: 'Trofea',
    counter: '{earned} / {total}',
    locked: 'Jeszcze nic nie zdobyto',
    userLocked: 'Ten gracz jeszcze nic nie zdobył',
    loading: 'Ładowanie…',
    userNotFound: 'Nie znaleziono użytkownika',
    loadFailed: 'Nie udało się załadować osiągnięć',
    secret: 'Tajne osiągnięcie',
    unlockedAt: 'Zdobyto {{date}}',
    progress: 'Postęp',
    ownedByPercent: 'Ma je {{percent}}% graczy',
    reward: 'Nagroda',
    claimReward: 'Odbierz nagrodę',
    depositToUnlock: 'Doładuj konto, żeby odebrać',
    recentReceivers: 'Ostatnio zdobyli',
    noOneUnlocked: 'Jeszcze nikt tego nie zdobył',
    you: 'Ty',
    today: 'Dzisiaj',
    receivedBy: 'Zdobyli:',
    playerOne: 'gracz',
    playerFew: 'graczy',
    playerMany: 'graczy',
    achievementUnlocked: 'Zdobyto osiągnięcie: {title}',
    achievementUnlockedFallback: 'Osiągnięcie zdobyte!',
    whatIsThis: 'Co to jest?',
    categoryAll: 'Wszystkie',
    categoryCases: 'Skrzynki',
    categoryUpgrades: 'Upgrade',
    categoryContracts: 'Kontrakty',
    categoryDeposits: 'Doładowania',
    categorySteam: 'Steam',
    categoryFriends: 'Znajomi',
    categoryActivity: 'Aktywność',
    categorySecret: 'Tajne',
    categoryRushmid: 'Rush Mid',
    categoryCasebattle: 'Case Battles',
    legendCredited: 'Naliczono',
    legendUnclaimed: 'Nagroda czeka',
  },
});

export default translations;
